<div id="ineligibility-content">
  <picture>
    <source media="(min-width: 767px)" srcset="assets/images/exclamation-triangle_96.png">
    <img id="ineligibility-icon" src="assets/images/exclamation-triangle_96.png" alt="Ineligibility icon">
  </picture>
  <h2 id="ineligibility-heading">{{cfetLabels.cfet_customer_eligibility.ineligibility_heading_utf}}</h2>
  <p id="ineligibility-desc" [innerHTML]="cfetLabels.cfet_customer_eligibility.ineligibility_desc_utf">
  </p>
  <hr id="ineligibility-section">
  <div class="col-md-12 btn-container" id="ineligible-footer-column">
    <button tabindex="0" type="button" id="btn-back" class="btn btn-alt btn-medium" (click)="goBack($event)"
      (keyup)="goBack($event)">
      {{cfetButtonLabels.button_labels.go_back}}</button>
  </div>
  <span>
    <a tabindex="0" type="button" id="ineligibility-redirecttext" (click)="shopPlansDevices($event)"
      (keyup)="shopPlansDevices($event)"><em
        aria-label=""></em>{{cfetLabels.cfet_customer_eligibility.ineligibility_link_text_utf}}</a>
  </span>
</div>